import store from "../../Redux/store";
import { setEmissionsData } from "./Emissions.reducer";

export function saveEmissionsData(emissionsPerYear) {
  store.dispatch(setEmissionsData(emissionsPerYear));
}

